import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  form: {
    username: "",
    email: "",
    nombres: "",
    apellido_paterno: "",
    apellido_materno: "",
    rol: "",
    password: "",
    password2: "",
    plantel: 0,
    escuela: 0,
    telefono: "",
    correo: "",
    fecha_nacimiento: "",
    estado_civil: "",
    curp: "",
    rfc: "",
  },
};

const usersFormSlice = createSlice({
  name: "usersForm",
  initialState,
  reducers: {
    updateField: (state, action) => {
      const { name, value } = action.payload;
      state.form[name] = value;
    },
    resetForm: () => initialState,
  },
});

export const { updateField, resetForm } =
  usersFormSlice.actions;

export default usersFormSlice.reducer;
